export enum InitFetchState {
    ShouldInitFetch = 'ShouldFetch',
    WaitingInitFetchResponse = 'WaitingInitFetchResponse',
    InitFetchCompleted = 'InitFetchCompleted',
    InitFetchFailed = 'InitFetchFailed'
}